import { swiffyslider } from 'swiffy-slider'
import { queryAll, query } from '../utils/utils.js';
import "swiffy-slider/css"
window.swiffyslider = swiffyslider;

const slider = () => {
	initSlider();
};


function initSlider(){
	const sliders = queryAll('.bhs-slider');
	sliders.forEach((slider , i) => {

		slider.querySelectorAll('.slider-nav').forEach(( navbtn ) => {
			navbtn.classList.add('arrow-link');
			if ( navbtn.classList.contains( 'slider-nav-prev' ) && ! navbtn.hasAttribute( 'aria-label' ) ) {
				navbtn.setAttribute( 'aria-label', 'Previous slide' );
			}
			if ( navbtn.classList.contains( 'slider-nav-next' ) && ! navbtn.hasAttribute( 'aria-label' ) ) {
				navbtn.setAttribute( 'aria-label', 'Next slide' );
			}
		});

		slider.querySelectorAll( '.slider-indicators button' ).forEach( ( btn, index ) => {
			if ( ! btn.hasAttribute( 'aria-label' ) ) {
				btn.setAttribute( 'aria-label', `Go to slide ${ index + 1 }` );
			}
		});

		swiffyslider.initSlider(slider);
		
		swiffyslider.onSlideEnd(slider, function () {
			//query('.step-number .current').innerText = getSlideIndex(slider);
		});
	});
}

function getSlideIndex(sliderElement) {
    const container = sliderElement.querySelector('.slider-container');
	let slideIndex = 0;
    for (const slide of container.children) {
        var slideScrollLeftPosition = slide.getBoundingClientRect().left - container.getBoundingClientRect().left;
		slideIndex++;
        if (slideScrollLeftPosition >= -1 ) {
			return slideIndex;
        }
    }
    return 0;
}

export { slider };
